import { mySchedules } from './mySchedules';

export const es = { mySchedules };
